import { Icon } from '@chakra-ui/react';

export default function SFPencilIcon(props) {
  return (
    <Icon
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill='currentColor'
        d='m7.734 16.422.25-.445 9.516-9.47a.964.964 0 0 1 1.367.009.967.967 0 0 1 0 1.375L9.36 17.35l-.46.243zm-.992 1.797.633-1.133.852.852-1.172.609a.237.237 0 0 1-.313-.328'
      />
    </Icon>
  );
}
